import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import axios from 'axios'
import flatPickr from 'vue-flatpickr-component'
import store from './store/store'
import VueForm from "vue-form"
import Swal from "sweetalert2/dist/sweetalert2.js"
import PrimeVue from 'primevue/config';
import 'primeicons/primeicons.css' 
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Dialog from 'primevue/dialog';
import Rating from 'primevue/rating';
import Panel from 'primevue/panel';
import Textarea from 'primevue/textarea';

import 'flatpickr/dist/flatpickr.css'
import "sweetalert2/dist/sweetalert2.css"

import mainMixins from './mainMixins.js'

window.$ = window.jQuery = require('jquery')

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(PrimeVue);
Vue.mixin(mainMixins)

Vue.component('DataTable', DataTable);
Vue.component('Column', Column);
Vue.component('Dialog', Dialog);
Vue.component('Rating', Rating);
Vue.component('Panel', Panel);
Vue.component('Textarea', Textarea);

window.router = router
window.apiKS = "https://api.gcacademy.online/"
// window.apiKS = "http://apietc.loc/"
window.axios = axios
window.flatPickr = flatPickr
window.VueForm = VueForm
window.Vue = Vue
window.Swal = Swal
window.user = null
window.headers = null
window.Fire = new Vue()
window.hostname = 'gcacademy.online'
window.apiConekta = 'key_UAnsz7qgmkBmUSUQFE8CpdQ' // producción
// window.apiConekta = 'key_Kf5K7iPrxBh52WmbkbrmWsA' // desarrollo
//window.hostname = location.hostname

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 1000,
  timerProgressBar: true
})

window.Toast = Toast

window.clientAPI = {
    'Content-Type': 'application/json',
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNjc0NjljNTZlNjc5NmM2YmRjMzRhYjBhMmYxMThiY2Y0YjIxMGZmOTJjM2JmYmZjZjg1YzI2N2Y4MWJiYjRlMTZlNGQ4ODFlYjUyZWI4ZWIiLCJpYXQiOjE2ODMwMzk1MTMsIm5iZiI6MTY4MzAzOTUxMywiZXhwIjoxNzE0NjYxOTEzLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.LcCH3jdMknaSULqFgLfmJ1OKocw-JH8oR7YZ8XuWENpZN6k7-VM5gwwXJASo4n5MZLeGvPdmIFWUI1EftOhECXPeJBusp-e10jzemI5noKZx_wCVBzS32skYF2aFGlxer8FDfO8L4Oz5-C-wjK8lgJGmD8J5UrRq-QuIpxRkKB3AUbyBRK4A0Y3Rz1vBkAFow71UaLSiWmikrbR16kto9I5liznB_wSDTND4IbBYBmC6aH_cW6WAW42f5m84BkOsOa_y7tPKlE-plYYlixpEouNq7Ec5GR3YK8ECqP5IGwS5UWKTLApWwQd3QX93fPD_lcI5MM_8PV3YKhreaPVbO2J01Q1_7MwSvp457EB37LUjPMCF4v8idDXiiFwoEwZ34gwBzgzeOgkh0qWd8VGrxug6n1mflhF8aUBqNMAJAmPmS3qhJNTN-s_HToXZ7dIPWGF4T-ipUIQqBh_Eecq_MXLfZ1BZq0bktbuRulO2kRRpu4j-hLtBmzl2TNVTxI7dqdTVDi5hw7w_6wAIkm1Z4TQzeC5FGFIbKTWnOzqeyX4m3WKjWJZpxxPf_8FZaknB0d5-tNJjkoHuUD1JjqeXt54Hem-8Ua2xWxMiNadAP3agtL3rZbBsD58fTLuOTdmDIXgYvn5QsCVAome-X4bvQcxCl_XWodHJNPNVg14ol3E'
    // Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNjQwNzFlODE5ZjY4ZjhjYTFlNjE2OTc0OTAzMTk3NjU4MzA2MWE3OGU1MzIzODg2YzVhZDhkN2ExODc3MjA3YmZiMDZlOWQ3YWI1MDEzOGYiLCJpYXQiOjE2OTc1NTE2MTAsIm5iZiI6MTY5NzU1MTYxMCwiZXhwIjoxNzI5MTc0MDEwLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.QXzgJ1ixN2EQKVzXWCVK_LOJ5nWi9nBDmc8CFdVgwehIlXIf0oldOFjXBs15Ob4yT2o04PGml3Jgl5bv7LQLxDUgkWQ_-nfYhI0ZQbAGVIA4RNa1H6IwxGsL8POhI1tFBFC7WaiYXjGJY7fA_rAMx7Vt7_ClQY4Ynqp86c9AbTuHWiqJg1g6EQJhWR5380qCUHeKB3Ete52rHPYPRmv8b_7GU2sMG2Wp0dchhb4rQIYfPnEKYWy15DMz2uy4daiY52NZftRWAPjKHKIJqZ1SDuiKrBlMmFzi9b-rbJpF6RdawKhtCmsVLPyY3pvLTROo7LSyvRBK39Hq3ZpcCbA-GB6l28qqMbasO4Y7U3Ux5durfT_nU84HBIeYCvLpgyBLTCg-vZbw3qfuPfIR1F48HbS7CvnxBnYlXhf6WC-eATDCAg_PR8-KwFL2jYR5zOiO3gpl76Cqon2nK4FctIKBSWa322n3Y90pp9DAxZbDHIExjtuHznv7ZFAnwGfrw4d9dGbh4MZBxcxlEEGnhdxpWhxM-0BY9AyayOAiPuHtwTXSz4Qn6NdVQMR3iLbET9lIg5RI73A7icYFZ9qNzbv3-1gb2pWWwn6jkJSVk92hVCYPZlp8ePB7LRZB48C-cISbZBptM-BVotbhHJaWpzH41j6pStkFNZQEE7iX9i2NcvA'
}

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
